import { NgModule } from '@angular/core';
import {CommonModule} from "@angular/common";

import { BoolStringPipe } from './boolstring.pipe';

@NgModule({
  declarations:[BoolStringPipe],
  imports:[CommonModule],
  exports:[BoolStringPipe]
})

export class MainPipe{}